import { render, staticRenderFns } from "./SearchFilterTokens-v2.vue?vue&type=template&id=32d58c32&scoped=true&"
import script from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32d58c32",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('32d58c32')) {
      api.createRecord('32d58c32', component.options)
    } else {
      api.reload('32d58c32', component.options)
    }
    module.hot.accept("./SearchFilterTokens-v2.vue?vue&type=template&id=32d58c32&scoped=true&", function () {
      api.rerender('32d58c32', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2hZoESXrzHaqi/JS/comp/SearchFilterTokens-v2.vue"
export default component.exports